import { MainService } from "../../services/optimizer-service/optimizer.service";
import { MatDialog } from "@angular/material";
import { QuickDialog } from "../Dialog/QuickDialog";

/** True when address or coordinates changed (only these affect route-based delivery fees). */
export function stopLocationChanged(
    before: { address?: string; lat: any; lng: any },
    after: { address?: string; lat: any; lng: any }
): boolean {
    if ((before.address || '').trim() !== (after.address || '').trim()) {
        return true;
    }
    return Number(before.lat) !== Number(after.lat) || Number(before.lng) !== Number(after.lng);
}

export class DeliveryFeeCalculation {


    constructor(private dialog: MatDialog, private main: MainService, private courierKey: string, private stops: any[], private settings: any, public cumulative: boolean) {

    }

    async calculateDeliveryFee(added) {
        if (this.stops.length > 0 && this.settings.deliveryFee.enabled) {
            var d = new QuickDialog(this.dialog).LoadingDialog("Calculating Delivery Fee...");
            try {
                var response = null;
                if (this.cumulative) {
                    var locations = [];
                    for (var i = 0; i < this.stops.length; i++) {
                        if (i > 0) {
                            locations.push(this.stops[i].location);
                        }
                    }
                    locations.push(added.location);
                    response = await this.main.getDeliveryFee(this.stops[0].location, added.location, locations, this.courierKey);
                    this.stops.forEach(s => {
                        s.fee = 0;
                    })
                    this.stops[this.stops.length - 1].fee = response.fee;
                }
                else {
                    response = await this.main.getDeliveryFee(this.stops[0].location, added.location, [], this.courierKey);
                    added.fee = response.fee;
                }
                return response;
            } catch (e) {
                console.log(e);
            } finally {
                d.close();
            }
        }
    }


    async recalculateDeliveryFee() {
        if (!this.settings.deliveryFee.enabled) {
            return;
        }
        let response;
        if (this.stops.length > 0 && this.cumulative) {
            response = await this.calculateDeliveryFee(this.stops[this.stops.length - 1]);
        } else {
            response = await this.recalculateIndividualDeliveryFee();
        }
        return response;
    }

    async recalculateIndividualDeliveryFee() {
        var d = new QuickDialog(this.dialog).LoadingDialog("Calculating Delivery Fee...");
        let lastResponse;
        if (!this.cumulative && this.stops.length > 0) {
            for (var i = 1; i < this.stops.length; i++) {
                var response = await this.main.getDeliveryFee(this.stops[0].location, this.stops[i].location, [], this.courierKey);
                this.stops[i].fee = response.fee;
                lastResponse = response;
            }
        }
        d.close();
        return lastResponse;
    }

}